import { MasterButton, Modal, InputTextArea } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  defaultToastSuccess,
  defaultToastError,
  removeLocalStorageAsFormData,
  isNull,
  toUTCFormat,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4, WMS_LGS_PO } from "App/constants";
import {
  STATUS_PROCESS,
  STATUS_TRANSAKSI_DRAFT,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_PEMBELIAN,
  urlChangeStatus,
  urlCreatePO,
  urlCreatePOByIdReq,
  urlUpdatePO,
} from "../../helpers";
import { useDispatchWrapper } from "hooks";
import { Alert } from "@material-ui/lab";

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_PENGAJUAN = {
  label: "PENGAJUAN",
  color: "warning",
  state: true,
  disabled: false,
};

export const SHOW_PROCESS = {
  label: "SETUJUI",
  color: "green",
  state: true,
  disabled: false,
};

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: true,
  disabled: false,
};

const ModalSimpan = ({
  setShowModal,
  resetForm,
  setNewDataPoList,
  listPO,
  setListPO,
}) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT);
  const [disabledPengajuan, setDisabledPengajuan] = useState(SHOW_PENGAJUAN);
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const { setShowModalBarang, rowsSelect } = useContext(FormContext);

  const { state } = useDispatchWrapper();
  const code_menu = state.wrapper_active_tab;
  const menus = state.wrapper_tabs;
  const getMenu = menus.filter((e) => e.code === code_menu);

  const { formData, setFormData, validasi } = useContext(FormContext);

  const handleClickOpenDraf = async (e) => {
    e.preventDefault();
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        formData.date === "" ||
        isNull(formData.unit_id) ||
        isNull(formData.produsen_id) ||
        isNull(formData.penerima) ||
        isNull(formData.supplier_id)
      ) {
        switch (true) {
          case isNull(formData.unit_id):
            defaultToastError("Harap pilih unit !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case formData.date === "":
            defaultToastError("Harap pilih tanggal purchase order !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.produsen_id):
            defaultToastError("Harap pilih produsen !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.supplier_id):
            defaultToastError("Harap pilih supplier !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          case isNull(formData.penerima):
            defaultToastError("Nama penerima dibutuhkan !");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
          default:
            defaultToastError("Harap lengkapi form purchase order!");
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            setShowModal(false);
            break;
        }
      } else {
        if (listPO.length === 0 && formData.isRequest === false) {
          defaultToastError(
            "Harap mengisi data barang transaksi po terlebih dahulu!"
          );
          setDisabledOpenDraft(SHOW_OPEN_DRAFT);
          setShowModal(false);
          setShowModalBarang(true);
        } else {
          const api = await instance4.post(
            formData.isRequest ? urlCreatePOByIdReq : urlCreatePO,
            {
              id_request: formData.isRequest ? formData.idreq : null,
              tax: formData.tax,
              supplier_id: formData.supplier_id,
              produsen_id: formData.produsen_id,
              status_transaksi: STATUS_TRANSAKSI_DRAFT,
              status: true,
              remark: formData.remark,
              penerima: formData.penerima,
              gudang_id: formData.gudang_id,
              unit_id: formData.unit_id,
              date: toUTCFormat(formData.date),
              detail: listPO,
              barang: formData.isRequest ? rowsSelect : [],
            }
          );
          const res = await api?.data;
          if (res.status === 200) {
            setShowModal(false);
            defaultToastSuccess(res?.message);
            await setFormData({
              ...formData,
              id_request: "",
              idpo: res.data.header_po.id,
              nomorPo: res.data.header_po.nomorPO,
              isOpenDraf: true,
              isProcess: false,
              status_transaksi: STATUS_TRANSAKSI_DRAFT,
            });
            setNewDataPoList(res.data.header_po.id);
          } else {
            setDisabledOpenDraft(SHOW_OPEN_DRAFT);
            defaultToastError(res?.message);
          }
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickPengajuanPO = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    const barang = listPO;
    const checkHargaBarang = barang.filter((e) => e.harga === 0);
    if (checkHargaBarang.length === 0) {
      const checkQTYBarang = barang.filter((e) => e.qty === 0);
      if (checkQTYBarang.length === 0) {
        try {
          if (formData.date === "") {
            defaultToastError("Tanggal tidak boleh kosong!");
            setDisabledPengajuan(SHOW_PENGAJUAN);
          } else {
            const api = await instance4.post(urlChangeStatus, {
              id: formData.idpo,
              status: STATUS_PROCESS,
              status_transaksi: STATUS_TRANSAKSI_PENGAJUAN,
              id_request: formData.idreq,
              remark: formData.catatan_proses,
              kode_menu: getMenu[0].code,
              nama_menu: getMenu[0].name,
            });
            const res = await api?.data;
            if (res.status === 200) {
              removeLocalStorageAsFormData(WMS_LGS_PO);
              setShowModal(false);
              defaultToastSuccess(res?.message);
              setDisabledPengajuan(SHOW_PENGAJUAN);
              setFormData({
                ...formData,
                isProcess: true,
                catatan_proses: "",
                status_transaksi: STATUS_TRANSAKSI_PENGAJUAN,
              });
            } else {
              defaultToastError(res?.message);
              setDisabledPengajuan(SHOW_PENGAJUAN);
            }
            // resetForm();
          }
        } catch (error) {
          setDisabledPengajuan(SHOW_PENGAJUAN);
          defaultToastError(error?.response?.data?.message);
        }
      } else {
        defaultToastError(
          "Tidak dapat melanjutkan, karena terdapat barang dengan QTY 0 !"
        );
        setDisabledPengajuan(SHOW_PENGAJUAN);
      }
    } else {
      defaultToastError(
        "Tidak dapat melanjutkan, karena terdapat barang dengan harga 0 !"
      );
      setDisabledPengajuan(SHOW_PENGAJUAN);
    }
  };

  const handleClickProcess = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    if (validasi) {
      try {
        if (formData.date === "") {
          defaultToastError("Tanggal tidak boleh kosong!");
          setDisabledProcess(SHOW_PROCESS);
        } else {
          const api = await instance4.post(urlChangeStatus, {
            id: formData.idpo,
            status: STATUS_PROCESS,
            status_transaksi: STATUS_TRANSAKSI_DISETUJUI,
            id_request: formData.idreq,
            remark: formData.catatan_setuju,
            kode_menu: getMenu[0].code,
            nama_menu: getMenu[0].name,
          });
          const res = await api?.data;
          if (res.status === 200) {
            removeLocalStorageAsFormData(WMS_LGS_PO);
            setShowModal(false);
            defaultToastSuccess(res?.message);
            setDisabledProcess(SHOW_PROCESS);
            setFormData({
              ...formData,
              isProcess: true,
              catatan_setuju: "",
              status_transaksi: STATUS_TRANSAKSI_DISETUJUI,
            });
          } else {
            defaultToastError(res?.message);
            setDisabledProcess(SHOW_PROCESS);
          }
          // resetForm();
        }
      } catch (error) {
        setDisabledProcess(SHOW_PROCESS);
        defaultToastError(error?.response?.data?.message);
      }
    } else {
      setDisabledProcess(SHOW_PROCESS);
      defaultToastError("Anda tidak memiliki akses !");
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdatePO, {
          id: formData.idpo,
          penerima: formData.penerima,
          catatan: formData.remark,
          tax: formData.tax,
          remark: formData.remark,
          date: toUTCFormat(formData.date),
          detail: listPO,
          unit_id: formData.unit_id,
          supplier_id: formData.supplier_id,
          produsen_id: formData.produsen_id,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setNewDataPoList(formData.idpo);
        } else {
          setDisabledUpdate(SHOW_UPDATE);
          defaultToastError(res?.message);
        }
        // resetForm();
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{
          marginBottom: "1rem",
        }}
      >
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          disabledOpenDraft={disabledOpenDraft}
          handleClickOpenDraf={handleClickOpenDraf}
          disabledProcess={disabledProcess}
          handleClickPengajuanPO={handleClickPengajuanPO}
          disabledPengajuan={disabledPengajuan}
          handleClickProcess={handleClickProcess}
          disabledUpdate={disabledUpdate}
          handleClickUpdate={handleClickUpdate}
          formData={formData}
          setFormData={setFormData}
        />
      </Grid>
    </Modal>
  );
};

const ButtonCreate = ({
  isOpenDraf,
  disabledOpenDraft,
  handleClickOpenDraf,
  disabledPengajuan,
  handleClickPengajuanPO,
  disabledProcess,
  handleClickProcess,
  disabledUpdate,
  handleClickUpdate,
}) => {
  const { formData, setFormData } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <>
      {isOpenDraf ? (
        formData.status_transaksi === STATUS_TRANSAKSI_DRAFT ? (
          <>
            <Alert severity="info" variant="outlined" style={{ width: "100%" }}>
              Harap lakukan update request ketika melakukan perubahan data
            </Alert>
            <MasterButton
              className={"mt-1 mb-2 w-full text-center"}
              type={"button"}
              color={disabledUpdate.color}
              onClick={(e) =>
                disabledUpdate.disabled ? null : handleClickUpdate(e)
              }
              name={disabledUpdate.label}
              size="lg"
            />
            <InputTextArea
              className="mt-1 w-full"
              value={formData.catatan_proses}
              label={"Keterangan/Catatan Sebelum Pengajuan PO"}
              placeholder={""}
              onChange={handleChange("catatan_proses")}
              rows={"3"}
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledPengajuan.color}
              onClick={(e) =>
                disabledPengajuan.disabled ? null : handleClickPengajuanPO(e)
              }
              name={disabledPengajuan.label}
              size="lg"
            />
          </>
        ) : formData.status_transaksi === STATUS_TRANSAKSI_PENGAJUAN ? (
          <>
            <InputTextArea
              className="mt-1 w-full"
              value={formData.catatan_setuju}
              label={"Keterangan/Catatan Sebelum Menstujui PO"}
              placeholder={""}
              onChange={handleChange("catatan_setuju")}
              rows={"3"}
            />
            <MasterButton
              className={"mt-1 w-full text-center"}
              type={"button"}
              color={disabledProcess.color}
              onClick={(e) =>
                disabledProcess.disabled ? null : handleClickProcess(e)
              }
              name={disabledProcess.label}
              size="lg"
            />
            {/* <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledUpdate.color}
            onClick={(e) => handleClickUpdate(e)}
            name={disabledUpdate.label}
            size="lg"
          /> */}
          </>
        ) : formData.status_transaksi === STATUS_TRANSAKSI_DISETUJUI ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI TELAH DISETUJUI</>
          </div>
        ) : formData.status_transaksi === STATUS_TRANSAKSI_PEMBELIAN ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI DALAM PROSES PEMBELIAN</>
          </div>
        ) : (
          <div style={{ textAlign: "center", width: "100%" }}>
            <>TRANSAKSI SELESAI</>
          </div>
        )
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) =>
            disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)
          }
          size="lg"
        />
      )}
    </>
  );
};

export default ModalSimpan;
